"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const ControlRendererContext_1 = __importDefault(require("../../../ControlRendererContext"));
const style_1 = __importDefault(require("./style"));
const DialogWrapperRenderer = ({ title, description, onOkText, onCancelText, children, onOk, onCancel, }) => {
    var _a;
    const { Render, functions: { processor }, } = (0, react_1.useContext)(ControlRendererContext_1.default);
    const platform = (_a = processor === null || processor === void 0 ? void 0 : processor.root) === null || _a === void 0 ? void 0 : _a.platformOS;
    return (react_1.default.createElement(Render.Modal, { visible: true, animationType: "slide", transparent: true },
        react_1.default.createElement(Render.KeyboardAvoidingView, { behavior: platform === 'android' ? undefined : 'padding', style: style_1.default.container },
            react_1.default.createElement(Render.View, { style: platform === 'android' ? style_1.default.contentAndroid : style_1.default.contentIos },
                react_1.default.createElement(Render.View, { style: platform === 'android' ? style_1.default.headerAndroid : style_1.default.headerIos },
                    react_1.default.createElement(Render.Text, { style: platform === 'android' ? style_1.default.titleAndroid : style_1.default.titleIos }, title),
                    react_1.default.createElement(Render.Text, { style: platform === 'android' ? style_1.default.descriptionAndroid : style_1.default.descriptionIos }, description)),
                react_1.default.createElement(Render.View, { style: platform === 'android' ? style_1.default.contentWrapperAndroid : style_1.default.contentWrapperIos }, children),
                react_1.default.createElement(Render.View, { style: platform === 'android' ? style_1.default.footerAndroid : style_1.default.footerIos },
                    onCancel && (react_1.default.createElement(Render.TouchableOpacity, { style: platform === 'android' ? style_1.default.buttonAndroid : style_1.default.buttonIos, onPress: onCancel },
                        react_1.default.createElement(Render.Text, { style: platform === 'android' ? style_1.default.buttonTextAndroid : style_1.default.buttonTextAndroid }, onCancelText || (platform === 'ios' ? 'Cancel' : 'CANCEL')))),
                    react_1.default.createElement(Render.TouchableOpacity, { style: platform === 'android' ? style_1.default.buttonAndroid : style_1.default.buttonIos, onPress: onOk },
                        react_1.default.createElement(Render.Text, { style: platform === 'android' ? style_1.default.buttonTextAndroid : style_1.default.buttonTextAndroid }, onOkText || (platform === 'ios' ? 'Ok' : 'OK'))))))));
};
exports.default = DialogWrapperRenderer;
